import { Address } from "../input-address/address.model";

export class SiteDropdownOption {
  public id: string;
  public name: string;
  public country: string;
  public address: Address;
  public externalId: string;
  public trialId: string;
  public culture: string;
  public trialCode: string;
  public trialSiteNumber: string;
  public stateOnTrial: number;
  public apiConsumerId: string;
  public apiConsumerName: string;


  constructor(init: Partial<SiteDropdownOption>) {
    Object.assign(this, init)
  }
}
